import { colors, devices } from '../../config/theme'

const style = {}

style.base = {
  backgroundColor: '#FF5555',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.white,
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  fontWeight: '500',
  zIndex: '525252',
  boxShadow: '0px 1px 1px rgba(0,0,0,0.1)',
  '& span': {
    textAlign: 'center',
    width: '98%',
    paddingLeft: '17px',
    paddingRight: '17px'
  },
  '& img': {
    paddingRight: '25px',
    float: 'right',
    filter: 'invert(1)',
    cursor: 'pointer',
    height: '12px'
  }
}

style.success = {
  backgroundColor: '#6164FF !important'
}

style.warning = {
  backgroundColor: '#6164FF !important'
}

style.base[devices.mobile] = {
  height: '71px',
  '& img': {
    height: '17px'
  }
}
style.base[devices.desktop] = {
  height: '54px'
}

export default style
